/**
 * File: apps/qbench-cp/reactapp/src/Dashboard/styles.js
 *
 * Purpose: Styled-components definitions for the dashboard's scrollable content area.
 *
 * Scope: Dashboard layout wrapper used by Dashboard/index.js.
 *
 * Tags: customer-portal
 *
 * Overview: Exports StyledDashboard, a full-height (minus the top nav) scrollable container
 *     themed via the theme palette's background color, whose `.wideScreen` child constrains
 *     content to a max width and centers it on wide-screen viewports per the theme's device
 *     breakpoint.
 *
 * Exports: StyledDashboard — styled div used as the dashboard's outer scroll container.
 */

import styled from 'styled-components';

export const StyledDashboard = styled.div`
  height: calc(100vh - 56px);
  background: ${({ theme }) => theme.color.palette.background.paper.portalbg};
  overflow-y: auto;
  position: relative;

  & .wideScreen {
    height: 100%;

    @media ${({ theme }) => theme.device.wideScreen} {
      max-width: 1480px;
      margin: 0 auto;
    }
  }
`;
